"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEntitlement = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
//////////////////////////////////////////////////////////////////////////////////
exports.setEntitlement = (0, toolkit_1.createAction)('SET_ENTITLEMENT');
/////////
